
import { Instagram } from 'lucide-react';
import { useInView } from '../utils/animations';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { useIsMobile } from '@/hooks/use-mobile';
import ig1 from '@/assets/instagram/ig1.png.asset.json';
import ig2 from '@/assets/instagram/ig2.png.asset.json';
import ig3 from '@/assets/instagram/ig3.png.asset.json';
import ig4 from '@/assets/instagram/ig4.png.asset.json';
import ig5 from '@/assets/instagram/ig5.png.asset.json';
import ig6 from '@/assets/instagram/ig6.png.asset.json';
import ig7 from '@/assets/instagram/ig7.png.asset.json';
import ig8 from '@/assets/instagram/ig8.png.asset.json';

const INSTAGRAM_URL = 'https://www.instagram.com/czule.klisze/';
const posts = [ig1, ig2, ig3, ig4, ig5, ig6, ig7, ig8];

const InstagramFeed = () => {
  const [titleRef, titleInView] = useInView({ threshold: 0.1 });
  const [feedRef, feedInView] = useInView({ threshold: 0.1 });
  const isMobile = useIsMobile();

  return (
    <section id="instagram" className="section bg-elegant-50">
      <div className="container-custom">
        <div
          ref={titleRef as any}
          className={`text-center max-w-2xl mx-auto mb-8 ${
            titleInView ? 'opacity-100 translate-y-0 transition-all duration-700' : 'opacity-0 translate-y-10 transition-all duration-700'
          }`}
        >
          <h2 className={`section-title ${isMobile ? 'text-2xl' : ''}`}>Śledź Nas na Instagramie</h2>
          <p className={`section-subtitle ${isMobile ? 'text-xs' : ''}`}>
            Zobacz nasze najnowsze realizacje i kulisy sesji
          </p>
        </div>

        <div
          ref={feedRef as any}
          className={`grid grid-cols-3 sm:grid-cols-4 md:grid-cols-4 gap-1 md:gap-3 ${
            feedInView ? 'opacity-100 translate-y-0 transition-all duration-700 delay-200' : 'opacity-0 translate-y-10 transition-all duration-700'
          }`}
        >
          {posts.map((post, index) => (
            <a
              key={index}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="instagram-post overflow-hidden relative block"
            >
              <AspectRatio ratio={4 / 5} className="w-full h-full">
                <img
                  src={post.url}
                  alt={`Instagram @czule.klisze ${index + 1}`}
                  loading="lazy"
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                />
              </AspectRatio>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="elegant-button-outline inline-flex items-center"
          >
            <Instagram className="mr-2 h-4 w-4" />
            Obserwuj @czule.klisze
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
